import React from "react";

// Chakra imports
import { Flex, useColorModeValue } from "@chakra-ui/react";

// Custom components
import logo from "assets/img/images/logo10.png"
import { HSeparator } from "components/separator/Separator";

export function SidebarBrand() {

  return (
    <Flex align='center' direction='column'>
     <img src={logo} style={{backgroundColor:"#5E17EB"}}></img>
     <HSeparator mb='20px' /> 
    </Flex>
  );
}

export default SidebarBrand;
